import {
  FETCH_ONBOARDING_SETTINGS_SUCCESS,
  HIDE_CONFIRMATION,
  HIDE_LOADING_INDICATOR,
  SHOW_CONFIRMATION,
  SHOW_LOADING_INDICATOR,
} from "./actionTypes"

const INITIAL_STATE = {
  showLoadingIndicator: true,
  onboardingSettings: null,
  isConfirmationVisible: false,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ONBOARDING_SETTINGS_SUCCESS:
      return {
        ...state,
        onboardingSettings: action.payload,
      }
    case SHOW_CONFIRMATION:
      return {
        ...state,
        isConfirmationVisible: true,
      }
    case HIDE_CONFIRMATION:
      return {
        ...state,
        isConfirmationVisible: false,
      }
    case SHOW_LOADING_INDICATOR:
      return {
        ...state,
        showLoadingIndicator: true,
      }
    case HIDE_LOADING_INDICATOR:
      return {
        ...state,
        showLoadingIndicator: false,
      }
    default:
      return state
  }
}
